import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { useCallback } from "react";
import type { JobType } from "@/types";
import { useAppDispatch, useAppSelector } from "./hooks";
import type { RootState } from "./store";

interface ServiceFusionState {
  jobType: JobType | null;
}

const initialState: ServiceFusionState = {
  jobType: null,
};

const serviceFusionSlice = createSlice({
  name: "serviceFusion",
  initialState,
  reducers: {
    setJobType: (state, action: PayloadAction<JobType | null>) => {
      state.jobType = action.payload;
    },
  },
});

const { setJobType } = serviceFusionSlice.actions;

const selectJobType = (state: RootState) => state.serviceFusion.jobType;

export const { reducer } = serviceFusionSlice;

export const useServiceFusionIntegration = () => {
  const dispatch = useAppDispatch();
  return {
    jobType: useAppSelector(selectJobType),
    setJobType: useCallback(
      (jobType: JobType | null) => dispatch(setJobType(jobType)),
      [dispatch],
    ),
  };
};
